import cloneDeep from 'lodash/cloneDeep'
import dividersDefaults from '../BaseDividers/BaseDividers.defaults'
import baseDefaults from '../Base/Base.defaults'
import baseBackground from '../BaseBackground/BaseBackground.defaults'

export default {
  ...cloneDeep(baseDefaults),
  dividers: cloneDeep(dividersDefaults),
  background: cloneDeep(baseBackground),
  height: 'auto',
  width: 'wide',
  verticalAlignment: 'center',
  styles: {
    desktop: {
      root: {
        default: {
          spacing: {
            padding: {
              top: 50,
              bottom: 50,
              left: 20,
              right: 20,
              unit: 'px'
            }
          }
        }
      }
    }
  }
}
